export default {
      id: "finance-options-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#finance-options",
      toString: function () {
        return this.url;
      }
    }